/* eslint-disable */
export default {
  noActiveCalls: 'Ei käynnissä olevia puheluita',
  currentCall: 'Nykyinen puhelu',
  ringCall: 'Soitettava puhelu',
  onHoldCall: 'Puhelu pidossa',
  otherDeviceCall: 'Käynnissä olevat puhelut muilla laitteillani',
  confirmation: 'Vahvistus',
  confirmMergeToConference: 'Lisätäänkö neuvottelupuheluun?',
  mergeToConference: 'Yhdistä',
  conferenceCall: 'Neuvottelupuhelu',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
